import { createContext } from 'react';
import { IDimensions } from 'components';

export const DimensionsContext = createContext<IDimensions>({
  width: 0,
  height: 0,
});
export const DimensionsProvider = DimensionsContext.Provider;
